/**
 * Single source of truth for business identity (NAP) data.
 * Displayed identically across Footer, Contact, About, and structured data
 * so it matches the Google Merchant Center business information exactly.
 */
export const BUSINESS = {
  name: "Lecis Auto Glass",
  phoneDisplay: "(888) 785-1288",
  phoneHref: "+18887851288",
  email: "support@lecisautoglass.com",
  infoEmail: "info@lecisautoglass.com",
  address: {
    line1: "8506 Madison Ave, Suite A",
    city: "Fair Oaks",
    region: "CA",
    postalCode: "95628",
    country: "US",
  },
  hoursDisplay: "Monday – Friday, 8:00 AM – 5:00 PM Pacific Time",
  hoursShort: "Mon–Fri · 8AM–5PM PT",
  responseTime: "We typically respond within one business day.",
  experience: "15+ Years of Auto Glass Industry Experience",
};

/** Full single-line address string used for display + structured data. */
export const ADDRESS_ONE_LINE = `${BUSINESS.address.line1}, ${BUSINESS.address.city}, ${BUSINESS.address.region} ${BUSINESS.address.postalCode}`;

/** schema.org PostalAddress object for JSON-LD. */
export const POSTAL_ADDRESS_LD = {
  "@type": "PostalAddress",
  streetAddress: BUSINESS.address.line1,
  addressLocality: BUSINESS.address.city,
  addressRegion: BUSINESS.address.region,
  postalCode: BUSINESS.address.postalCode,
  addressCountry: BUSINESS.address.country,
};
